import { Offers } from './Offers/Offers';
import { Declined } from './Declined/Declined';
import { Pending } from './Pending/Pending';
import { NotRegistered } from './NotRegistered/NotRegistered';
import { Closed } from './Closed/Closed';
import { AllBanks } from './AllBanks/AllBanks';
import { AllRegistrations } from './AllRegistrations/AllRegistrations';

export function BankPanels() {
  return null;
}

BankPanels.Offers = Offers;
BankPanels.Declined = Declined;
BankPanels.Pending = Pending;
BankPanels.NotRegistered = NotRegistered;
BankPanels.Closed = Closed;
BankPanels.AllBanks = AllBanks;
BankPanels.AllRegistrations = AllRegistrations;
